import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Grid,
} from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
// import SaveProductButton from "./SaveProductButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useRecordContext } from "react-admin";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";
import CustomLoanSkipDialog from "../../loans/actions/CustomLoanSkipDialog";
import { useWatch } from "react-hook-form";
import customSortArrays from "../../unit/sortArrays";
import { display, margin } from "@mui/system";

const RequirementAccountOpenField = ({ item, proAttrdata, control }: any) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        alignItems: "flex-start",
        mt: 1,
      }}
    >
      <Controller
        name={`reqs_${item.sIdentifier}_fields_account_type`}
        control={control}
        defaultValue={proAttrdata?.reqs_account_fields_account_type}
        render={({ field }) => (
          <CustomProductTextField
            {...field}
            variant="outlined"
            label="Account Type"
            small
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
          />
        )}
      />
      <Controller
        name={`reqs_${item.sIdentifier}_fields_apy`}
        control={control}
        defaultValue={proAttrdata?.reqs_account_fields_apy}
        render={({ field }) => (
          <CustomProductTextField
            {...field}
            variant="outlined"
            label="APY"
            small
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
          />
        )}
      />
      <Controller
        name={`reqs_${item.sIdentifier}_fields_interest_type`}
        control={control}
        defaultValue={proAttrdata?.reqs_account_fields_interest_type}
        render={({ field }) => (
          <CustomProductSelect
            {...field}
            variant="outlined"
            label="Interest"
            small
            optionlist={[
              { value: "Fixed", label: "Fixed" },
              { value: "Variable", label: "Variable" },
            ]}
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
            sx={{ width: "110px", maxWidth: "110px" }}
          />
        )}
      />
      <Controller
        name={`reqs_${item.sIdentifier}_fields_interest_rate`}
        control={control}
        defaultValue={proAttrdata?.reqs_account_fields_interest_rate}
        render={({ field }) => (
          <CustomProductTextField
            {...field}
            variant="outlined"
            label="Rate"
            small
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
          />
        )}
      />
    </Box>
  );
};

const ItemReqValueField = ({ item, control }: any) => {
  if (item.optionType == "numeric") {
    return (
      <Controller
        name={`reqs_value_${item.id}`}
        control={control}
        defaultValue={item.sValue}
        render={({ field }) => (
          <CustomProductIntTextField
            {...field}
            small
            // sx={{
            //   backgroundColor: "purple",
            //   "& .MuiInputBase-input": {
            //     background: "purple",
            //   },
            // }}
          />
        )}
      />
    );
  } else if (item.optionType == "string") {
    if (
      item.sIdentifier == "BUSINESS_ACTIVITY_MAY_NOT_INVOLVE" ||
      item.sIdentifier == "LOAN_NOT_USED"
    ) {
      return (
        <Controller
          name={`reqs_value_${item.id}`}
          control={control}
          defaultValue={item.sValue}
          render={({ field }) => (
            <CustomProductTextField
              {...field}
              variant="outlined"
              small
              fullWidth
              multiline
              rows={3}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              // sx={{
              //   backgroundColor: "pink",
              //   "& .MuiInputBase-input": {
              //     background: "pink",
              //   },
              // }}
            />
          )}
        />
      );
    } else {
      return (
        <Controller
          name={`reqs_value_${item.id}`}
          control={control}
          defaultValue={item.sValue}
          render={({ field }) => (
            <CustomProductTextField
              {...field}
              variant="outlined"
              small
              fullWidth
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              // sx={{
              //   backgroundColor: "yellow",
              //   "& .MuiInputBase-input": {
              //     background: "yellow",
              //   },
              // }}
            />
          )}
        />
      );
    }
  } else if (item.optionType == "date") {
    return (
      <Controller
        name={`reqs_value_${item.id}`}
        control={control}
        defaultValue={item.sValue}
        render={({ field }) => (
          <CustomProductTextField
            {...field}
            variant="outlined"
            small
            fullWidth
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
            // sx={{
            //   backgroundColor: "green",
            //   "& .MuiInputBase-input": {
            //     background: "green",
            //   },
            // }}
          />
        )}
      />
    );
  } else if (item.optionType == "boolean") {
    return (
      <Controller
        name={`reqs_value_${item.id}`}
        control={control}
        defaultValue={item.sValue}
        render={({ field }) => (
          <CustomProductSelect
            {...field}
            variant="outlined"
            small
            fullWidth
            optionlist={[
              { value: "Na", label: "" },
              { value: "Yes", label: "YES" },
              { value: "No", label: "NO" },
            ]}
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
            // sx={{
            //   backgroundColor: "blue",
            //   "& .MuiInputBase-input": {
            //     background: "blue",
            //   },
            // }}
          />
        )}
      />
    );
  }
  return null;
};

const RequirementGrid = ({
  item,
  isLastRow,
  proAttrdata,
  control,
  setValue,
  mutuallyExclusiveRequirements,
}: any) => {
  const isSelected = useWatch({
    control: control as any,
    name: `reqsId_${item.id}` as any,
    defaultValue: item.isSelect == true ? true : false,
  }) as boolean;
  const showVisible = !!isSelected;

  return (
    <>
      <Grid
        container
        sx={{
          borderBottom: isLastRow ? "none" : "1px solid #e0e0e0",
        }}
      >
        <Grid item xs={1} md={1} sx={{ display: "flex", alignItems: "center" }}>
          <Controller
            name={`optionId_${item.id}`}
            control={control}
            defaultValue={item.optionId}
            render={({ field }) => <input type="hidden" {...field} />}
          />
          <Controller
            name={`reqsId_${item.id}`}
            control={control}
            defaultValue={item.isSelect == true ? true : false}
            render={({ field }) => (
              <Checkbox
                {...field}
                checked={!!field.value}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const currentItemId = Number(item.id);
                  const linkedItemId =
                    mutuallyExclusiveRequirements[currentItemId];

                  field.onChange(checked);
                  setValue(`reqs_visiable_${item.id}`, checked ? 1 : 0);

                  if (checked && linkedItemId) {
                    setValue(`reqsId_${linkedItemId}`, false, {
                      shouldDirty: true,
                    });
                    setValue(`reqs_visiable_${linkedItemId}`, 0, {
                      shouldDirty: true,
                    });
                  }
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={4} md={4} sx={{ display: "flex", alignItems: "center" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: item.sLenderTitle,
            }}
          />
        </Grid>
        <Grid item xs={3} md={3} sx={{ display: "flex", alignItems: "center" }}>
          {item.sIdentifier !== "REFERRAL_NUMBER" &&
            item.sIdentifier !== "INSTITUTION_MAX_LOANS" &&
            item.sIdentifier !== "BANKING_NEGATIVE_RECORDS" && (
              <>{item.optionLabel}</>
            )}
        </Grid>
        <Grid item xs={3} md={3}>
          {item.sIdentifier !== "REFERRAL_NUMBER" &&
            item.sIdentifier !== "INSTITUTION_MAX_LOANS" &&
            item.sIdentifier !== "BANKING_NEGATIVE_RECORDS" && (
              <ItemReqValueField item={item} control={control} />
            )}

          {(item.sIdentifier == "ACCOUNT_MUST_OPEN" ||
            item.sIdentifier == "ACCOUNT_TO_OPEN") &&
            showVisible && (
              <RequirementAccountOpenField
                item={item}
                proAttrdata={proAttrdata}
                control={control}
              />
            )}
        </Grid>
        <Grid item xs={1} md={1} sx={{ display: "flex", alignItems: "center" }}>
          <Controller
            name={`reqs_visiable_${item.id}`}
            control={control}
            defaultValue={item.bVisiable == 1 ? 1 : 0}
            render={({ field }) => (
              <CustomProductSelect
                {...field}
                variant="outlined"
                small
                fullWidth
                optionlist={[
                  { value: 1, label: "YES" },
                  { value: 0, label: "NO" },
                ]}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  setValue(`reqsId_${item.id}`, e.target.value == 1 ? 1 : 0);
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default function Underwriting({ onSave, defaultValues, ...props }: any) {
  const mutuallyExclusiveRequirements = React.useMemo<Record<number, number>>(
    () => ({
      22: 92,
      92: 22,
    }),
    []
  );
  const record = useRecordContext();
  const sectionName = "underwriting";
  const sectionTitle = "Underwriting - Set requirements used in underwriting";
  const sectionSubtitle = "";
  const [isActualDirty, setIsActualDirty] = React.useState(false);
  const [initialValuesSet, setInitialValuesSet] = React.useState({});
  // const data = record?.data?.basic?.sectionName;
  // const data = record?.data?.basic?.underwriting;
  // const requirementData = data?.requirementData || [];
  const [showDetail, setShowDetail] = React.useState(false);
  // ⚡️ 关键：使用 useMemo 缓存数据，避免多次渲染
  const data = React.useMemo(
    () => record?.data?.basic?.underwriting,
    [record?.data?.basic?.underwriting] // 只在真实数据变化时更新
  );

  const requirementData = React.useMemo(
    () => data?.requirementData || [],
    [data]
  );

  const proAttrdata = React.useMemo(
    () => data?.proAttrdata || [],
    [data?.proAttrdata]
  );
  console.log("Check proAttrdata:", proAttrdata);

  const hasSetBaseline = React.useRef(false);
  // const [actualDirty, setActualDirty] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: {},
  });

  // 现有的初始化代码保持不变
  React.useEffect(() => {
    const rafId = requestAnimationFrame(() => {
      if (!hasSetBaseline.current) {
        const currentValues = getValues();
        setInitialValuesSet(currentValues);
        reset(currentValues);
        hasSetBaseline.current = true;
      }
    });
    return () => cancelAnimationFrame(rafId);
  }, [getValues, reset]);

  React.useEffect(() => {
    // 只在初始化后执行
    if (!hasSetBaseline.current) return;

    // 检查是否有真正修改的字段
    const hasRealChanges = Object.keys(dirtyFields).length > 0;

    // 更新实际脏状态
    setIsActualDirty(hasRealChanges);

    // 通知父组件
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, hasRealChanges);
    }
  }, [dirtyFields, props?.curMenu]);

  React.useEffect(() => {
    // console.log("Check when isDirty changed=====>:", isDirty);
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);

  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    console.log("Check Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };
  return (
    <SectionStyled id="section_uploaddocs">
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {Object.entries(requirementData as Record<string, any[]>).map(
          ([category, items]: [string, any[]]) => (
            <>
              {/* {category}--{items.length}---
            <br /> */}
              {items.length > 0 && (
                <Accordion key={category} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    {category}
                  </AccordionSummary>
                  <AccordionDetails>
                    {items.map((item, index) => (
                      <RequirementGrid
                        key={item.id ?? `${category}-${index}`}
                        item={item}
                        isLastRow={index === items.length - 1}
                        proAttrdata={proAttrdata}
                        control={control}
                        setValue={setValue}
                        mutuallyExclusiveRequirements={
                          mutuallyExclusiveRequirements
                        }
                      />
                    ))}
                  </AccordionDetails>
                </Accordion>
              )}
            </>
          )
        )}
      </Box>
      {/* Form Actions */}
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
